module.exports = __webpack_public_path__ + "img/print.67c3c9e3.svg";